export default [
    // {
    //   "statusName": "AttendedCount",
    //   "status": "Total Employees",
    //   "bgColor": "#fff",
    //   "totalCount": 0,
    //   "statusId": [32],
    //   "darkColor": "#b6e5b9",
    // },
    {
      "statusName": "Total Sponsored",
      "status": "Total Sponsered Booking",
      "bgColor": "#fff",
      "totalCount": 0,
      "statusId": [22],
      "darkColor": "#f0b0e4",
    },
    {
      "statusName": "Availed Sponsored",
      "status": "Availed Sponsered Booking",
      "bgColor": "#fff",
      "totalCount": 0,
      "statusId": [24,30,31,40],
      "darkColor": "#a3cbff",
    },
    {
      "statusName": "Total Paid",
      "status": "Total Paid Booking",
      "bgColor": "#fff",
      "totalCount": 0,
      "statusId": [22],
      "darkColor": "#bfe5c1",
    },
    {
      "statusName": "Availed Paid",
      "status": "Availed Paid Booking",
      "bgColor": "#fff",
      "totalCount": 0,
      "statusId": [22],
      "darkColor": "#ffe0af",
    },
  ];